import {
  DescriptionFormFieldMui as DescriptionFormField,
  FormFieldsBoxMui as FormFieldsBox,
  NameFormFieldMui as NameFormField,
} from '@spotify/confidence-core-react';
import { OwnerFormFieldMui as OwnerFormField } from '@spotify/plugin-confidence-permissions-react';

export type ResourceType = 'metric' | 'measurement';

type AboutFormFieldsProps = {
  resourceType?: ResourceType;
};

export const AboutFormFields = ({
  resourceType = 'metric',
}: AboutFormFieldsProps) => {
  return (
    <FormFieldsBox spacing={2}>
      <NameFormField name="metric-name" data-testid="metric-name" />
      <DescriptionFormField
        name="metric-description"
        minRows={5}
        maxRows={5}
        placeholder={`Add a short description of the ${resourceType}`}
        data-testid="metric-description"
      />
      <OwnerFormField />
    </FormFieldsBox>
  );
};
